// Single source of truth for the skill-mention markup contract.
//
// react-mentions inserts a token of this shape into the textarea when the user
// picks a skill from the `/` picker. The token then flows through two readers
// that must agree on its shape:
//   1. The AI Lambda — detects the markup in the user prompt and injects a
//      system instruction telling the model to invoke the named skill tool.
//   2. `PromptMarkdownPreviewV3` — strips the markup back to a `/display`
//      chip via `stripSkillMentions` so GFM doesn't render `(skill_name)` as
//      a clickable link in chat bubbles, scheduled prompt details, etc.
//
// Any change to the markup shape must update the Go-side parser in lockstep.

export const SKILL_MENTION_TRIGGER = '/';
export const SKILL_MENTION_MARKUP = '/[__display__](__id__)';

const SKILL_MENTION_RE = /\/\[([^\]]+)\]\(([^)]+)\)/g;

export function stripSkillMentions(value: string): string {
  return value.replace(SKILL_MENTION_RE, '/$1');
}
